import { render, staticRenderFns } from "./HelpMobileorderReorder.vue?vue&type=template&id=0cfc7c46&"
import script from "./HelpMobileorderReorder.vue?vue&type=script&lang=js&"
export * from "./HelpMobileorderReorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports